import {DayButton} from 'react-day-picker'
import styled, {css} from 'styled-components'

export const StyledDayButton = styled(DayButton)(
    ({theme: {typography, palette}}) => css`
        position: relative;
        ${typography.textSm};
        font-weight: 500;
        width: 100%;
        height: 100%;
        &.outside {
            color: ${palette.neutral['300']};
            pointer-events: none;
        }
    `
)
